import { render, staticRenderFns } from "./home - 鍓湰.vue?vue&type=template&id=2dc97e24&scoped=true"
import script from "./home - 鍓湰.vue?vue&type=script&lang=js"
export * from "./home - 鍓湰.vue?vue&type=script&lang=js"
import style0 from "./home - 鍓湰.vue?vue&type=style&index=0&id=2dc97e24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc97e24",
  null
  
)

export default component.exports